export class RentReminderContentPost {
    additionalText: string;
}
